/**
 * 定价结果面板组件
 * 职责：展示定价计算结果和物流渠道对比
 */
import React from 'react';
import { Row, Col, Card, Table, Statistic, Empty } from 'antd';
import { DollarOutlined, RiseOutlined } from '@ant-design/icons';
import { PricingLogicExplanation } from '../PricingLogicExplanation';

interface ChannelResult {
    key: string;
    channel: string;
    shippingCNY: number;
    landed: number;
    profit: number;
    margin: number;
    roi: number;
}

interface PricingResultsPanelProps {
    landedCost: number;
    fbaFee: number;
    referralRate: number;
    currentStorageFee: number;
    returnRate: number;
    otherCostRate: number;
    channelResults: ChannelResult[];
    selectedChannelId: string;
    channelColumns: any[];
    bestChannel?: ChannelResult | null;
}

export const PricingResultsPanel: React.FC<PricingResultsPanelProps> = ({
    channelResults,
    channelColumns,
    bestChannel,
}) => {
    // 如果没有渠道数据，显示提示
    if (!channelResults || channelResults.length === 0) {
        return (
            <>
                <Empty
                    description="请先配置物流渠道和定价参数"
                    style={{ margin: '40px 0' }}
                />
                <PricingLogicExplanation />
            </>
        );
    }

    return (
        <>
            {bestChannel && (
                <Row gutter={8} style={{ marginBottom: 8 }}>
                    <Col span={8}>
                        <Card size="small" bodyStyle={{ padding: '8px 12px' }}>
                            <Statistic
                                title={<span style={{ fontSize: 12 }}>最佳利润</span>}
                                value={bestChannel.profit}
                                precision={2}
                                prefix={<DollarOutlined />}
                                valueStyle={{ color: '#3f8600', fontSize: 18 }}
                            />
                        </Card>
                    </Col>
                    <Col span={8}>
                        <Card size="small" bodyStyle={{ padding: '8px 12px' }}>
                            <Statistic
                                title={<span style={{ fontSize: 12 }}>最佳利润率</span>}
                                value={bestChannel.margin}
                                precision={1}
                                prefix={<RiseOutlined />}
                                valueStyle={{ color: '#1890ff', fontSize: 18 }}
                                suffix="%"
                            />
                        </Card>
                    </Col>
                    <Col span={8}>
                        <Card size="small" bodyStyle={{ padding: '8px 12px' }}>
                            <Statistic
                                title={<span style={{ fontSize: 12 }}>ROI</span>}
                                value={bestChannel.roi}
                                precision={1}
                                valueStyle={{ color: '#722ed1', fontSize: 18 }}
                                suffix="%"
                            />
                        </Card>
                    </Col>
                </Row>
            )}

            <Table
                dataSource={channelResults}
                columns={channelColumns}
                pagination={false}
                size="small"
                bordered
                scroll={{ y: 300 }}
            />

            <PricingLogicExplanation />
        </>
    );
};
